<template>
  <div class="job-filter">
    <template v-if="this.showAll">
      <div class="sd-notif warning sd-alert">
        <svg-icon icon="information" class="warning-icon" />
        <div class="content">Standaard worden alleen de eerste 20 matches getoond. Klik op de toggle om alle matches te tonen.</div>
      </div>
    </template>
    <div class="button-container">
      <div v-if="this.subbranch" class="subbranch-filter">
        <div class="input-container">
          <input id="po" type="radio" v-model="filterValues.subbranch" value="1"><label for="po"><span class="radio-button"></span>Basisonderwijs</label>
        </div>
        <div class="input-container">
          <input id="vo" type="radio" v-model="filterValues.subbranch" value="2"><label for="vo"><span class="radio-button"></span>Voorgezet onderwijs</label>
        </div>
        <div class="input-container">
          <input id="both" type="radio" v-model="filterValues.subbranch" value="1,2"><label for="both"><span class="radio-button"></span>Beide</label>
        </div>
      </div>
      <div v-if="this.showAll" @click="filterValues.showAll = !filterValues.showAll" class="filter-button">
        <span class="toggle" :class="filterValues.showAll ? 'active' : ''"></span>
        <span v-if="!filterValues.showAll">Toon alles</span>
        <span v-if="filterValues.showAll">Toon minder</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      user: '',
      filterValues: {
        showAll: false,
        maxShown: 20,
        subbranch: '1,2'
      },
    }
  },
  props: {
    showAll: Boolean,
    subbranch: Boolean
  },
  watch: {
    filterValues: {
      handler(val) {
        this.$emit("filter-change", val);
      },
      deep: true
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));

      this.filterValues.subbranch = this.user.sub_branch;

      this.$store.state.loading = false;
    },
  }
};
</script>
<style scoped>
.button-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 0;
}

.button-container .subbranch-filter {
  display: grid;
  grid-auto-flow: column;
  column-gap: 10px;
}

.button-container .subbranch-filter label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding-left: 25px;
}

.button-container .subbranch-filter input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 0;
  height: 0;
  opacity: 0;
}

.button-container .subbranch-filter label .radio-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  position: absolute;
  left: 0;
}

.button-container .subbranch-filter label .radio-button::before,
.button-container .subbranch-filter label .radio-button::after {
  display: block;
  position: absolute;
  border-radius: 100%;
  content: '';
}

.button-container .subbranch-filter label .radio-button::before {
  height: 100%;
  width: 100%;
  border: 1px solid #64513D;
  background-color: #FFF;
}

.button-container .subbranch-filter input:checked + label .radio-button::after {
  width: 50%;
  height: 50%;
  background-color: #64513D;
}

.filter-button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  margin-left: 10px;
}

.filter-button .toggle {
  display: block;
  position: relative;
  width: 30px;
  height: 10px;
  border-radius: 20px;
  background-color: lightgray;
  margin-right: 15px;
}

.filter-button .toggle:before {
  content: '';
  display: block;
  height: 100%;
  width: 0;
  border-radius: 20px;
  background-color: #FFCD00;
  transition: .3s ease-in-out;
}

.filter-button .toggle.active:before {
  width: 100%;
}

.filter-button .toggle::after {
  content: '';
  display: block;
  position: absolute;
  top: -5px;
  left: -10px;
  right: 100%;
  height: 20px;
  width: 20px;
  background-color: #FFCD00;
  border-radius: 100%;
  transition: .3s ease-in-out;
}

.filter-button .toggle.active::after {
  right: 0;
  left: calc(100% - 10px);
}
</style>